import { defineStore } from 'pinia';

export const useGeolocationStore = defineStore('geolocation', {
    state: () => ({
        isLocationLive: false
    }),
    actions: {
        geolocationLiveOn() {
            this.isLocationLive = true;
        },
        geolocationLiveOff() {
            this.isLocationLive = false;
        }
    }
});